module.exports = __webpack_public_path__ + "img/reference-vconsulting.37008f3c.webp";